import React, {
  useContext,
  useEffect,
} from 'react';
import {
  injectIntl,
  IntlShape
} from 'react-intl';
import { flowRight } from 'lodash';
import { AppContext } from '../app/AppProvider.component';
import { translateMessages } from '../../translations/message.utilities';
import { StaticMessagesKeys } from '../../translations/message.constants';

import { RecordEmpty } from '../../models/common.models';

export const MessagesRegistrarComponent = (props: {
  intl: IntlShape;
}): null => {
  const {
    setAppState
  } = useContext(AppContext);

  useEffect(() => {
    const translatedMessages = translateMessages(StaticMessagesKeys, props.intl);
    setAppState((prevState) => {
      return {
        ...prevState,
        messages: translatedMessages
      };
    });
  }, []);

  return null;
};

const enhance = flowRight(injectIntl);

const MessagesRegistrar = enhance(MessagesRegistrarComponent) as unknown as React.FC<RecordEmpty>;
export default MessagesRegistrar;
